import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import { GuardProps } from 'types';
import useConfig from 'hooks/useConfig';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }: GuardProps) => {
    let { user, isReady } = useAuth();
    let { ready } = useConfig();
    let navigate = useNavigate();
    useEffect(() => {
        if (isReady && ready && !user) {
            navigate('login', { replace: true });
        }
    }, [isReady, ready, !!user, navigate]);
    if (!user) {
        return null;
    }
    return children;
};

export default AuthGuard;
